@for (item of pastHk; track item; let pIndex = $index) {
  <ng-container class="removeFirstBorder">
    @if (item.last_cleaning) {
      <div class="item-past-hk">
        @if (pIndex > 0) {
          @if (!noPlan) {
            <div class="grey-line past-hk"></div>
          }
          @if (noPlan) {
            <div class="grey-line-full"></div>
          }
        }
        <tidy-card-list [hideIcon]="!blackList">
          @if (blackList) {
            <ion-icon name="close-circle" class="blacklist-icon" item-left tappable (click)="blackListHk('add', item.homekeeper);" />
          }
          <tidy-card-title item-label>
            <div class="regular-text">
              {{item.homekeeper.firstName }}
            </div>
            <div class="regular-text">
              Last cleaned  {{item.last_cleaning.date | parseDateTime: 'MMM d'}}
            </div>
          </tidy-card-title>
          <tidy-link item-right tappable (click)="goToPastHomekeeperPage(item)">Options</tidy-link>
        </tidy-card-list>
      </div>
    }
  </ng-container>
}
@if (showPastHk && pastHk.length === 0) {
  <div class="grey-line past-hk"></div>
  <tidy-card-list>
    <span item-left ></span>
    <tidy-card-title item-label>
      <div class="regular-text">
        You have no completed cleanings.
      </div>
    </tidy-card-title>
  </tidy-card-list>
}
